import { FormattedMessage } from "react-intl";

import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils";

import { CreateAWorkspaceHeading, SubHeading } from "../components";

export const NewUser = () => (
    <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
        <CreateAWorkspaceHeading />
        <SubHeading>
            <FormattedMessage
                id="signup.serviceCollection.newUser"
                defaultMessage="Workspaces are where people organize teams, work, and projects."
            />
        </SubHeading>
        <SiteActivation />
    </SignupBackgroundLayout>
);
